import { ResponsiveSection } from '@stitch-fix/mode-react';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';

const TermsPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Terms | Stitch Fix"
        canonicalUrl="https://www.stitchfix.com/terms"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="2fad387e-e97d-4ac3-bc28-f0a2c5f1ae35" />
      </ResponsiveSection>
    </Layout>
  );
};

export default TermsPage;
